export default function useBlocks(wannabeJson) {
  let result = wannabeJson;

  if (result) {
    if (typeof result == 'string') {
      try {
        result = JSON.parse(result);
      } catch (e) {
        console.log(e);
      }
    }

    if (result.blocks) {
      result = result.blocks;
    }
  }

  return result;
}
